import { Controller, useFormContext } from 'react-hook-form';

import type { AbstractOption } from '~shared/types/abstract-options';

import { Multiselect } from '@breeze/rhf-adapters';

import type { FiltersValue } from '../filters/filters';

export function StatusFilter<T extends string>({
  onFilterChanged,
  options,
}: {
  options: AbstractOption<T>[];
  onFilterChanged: () => void;
}) {
  const { control } = useFormContext<FiltersValue<T>>();
  return (
    <Controller
      name="statuses"
      control={control}
      render={(fieldProps) => (
        <Multiselect
          {...fieldProps}
          label="Status"
          size="m"
          options={options}
          onClose={onFilterChanged}
        />
      )}
    />
  );
}
